import { useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../../components/input/Input";
import { useParams } from "react-router-dom";
import { useUpdateQuizQuestion } from "../hooks/useUpdateQuizQuestion";
import Button from "../../../../components/Button";
import Fileponds from "../../../../components/filepond/Filepond";

function UpdateQuestion({ row, onCloseModal }) {
    const { question, image, id } = row;
    const [questionImage, setQuestionImage] = useState(image);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            question,
        },
    });

    const { courseId, lectureId, itemId } = useParams();
    const {
        updateQuizQuesion,
        isUpdating,
        error: ApiError,
    } = useUpdateQuizQuestion();

    function onSubmit({ question }) {
        //Send The Form Data To The API

        updateQuizQuesion(
            {
                courseId,
                lectureId,
                itemId,
                questionId: id,
                question,
                image: questionImage?.[0]?.serverId,
            },
            {
                onSuccess: () => {
                    reset();
                    onCloseModal?.();
                },
            }
        );
    }

    return (
        <>
            <h3 className="py-5 text-xl text-center text-blue-color-primary">
                إنشاء سؤال
            </h3>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                <Input
                    label={"السؤال"}
                    name={"question"}
                    register={register("question", {
                        required: "يرجا إدخال أسم الكورس",
                    })}
                    error={
                        errors?.question?.message ||
                        ApiError?.response?.data?.errors?.question?.[0]
                    }
                    type="text"
                    size="full"
                    disabled={isUpdating}
                />

                <p>تعدبل الصوره:</p>

                <Fileponds imageToken={setQuestionImage} />

                <div className="w-full pt-3">
                    <Button
                        type="primary"
                        className="w-full leading-8"
                        disabled={isUpdating}
                    >
                        تعديل السؤال
                    </Button>
                </div>
            </form>
        </>
    );
}

export default UpdateQuestion;
